import React from 'react';
import styles from '../ManagePage.module.css';
import { convertToPoints, getScoreColor } from '../../../components/ListingScore/scoreUtils';

// e.g. "16 Nov 2025" — shared with BulkScoreCard
export const formatScoreDate = (d) => {
    if (!d) return '';
    const date = new Date(d);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

// Single-ASIN listing-score card for the Manage page — mirrors SingleProjectCard's
// layout, with a score row instead of the listing-mode tag and a "Score" edge badge.
const SingleScoreCard = ({ result, onViewScore }) => {
    const hasScore = result.has_score;
    const score = result.score || 0;
    const title = result.product_info?.title;
    const mainImage = result.product_info?.main_image;

    const handleView = () => {
        if (hasScore) onViewScore(result.asin, result);
    };

    return (
        <div className={styles.generationCard} onClick={hasScore ? handleView : undefined}>
            <div className={`${styles.recentProjectInner} ${styles.scoreCardInner}`}>
                <div className={styles.cardImage}>
                    {mainImage ? (
                        <img
                            src={mainImage}
                            alt={title || result.asin || 'Product image'}
                            className={styles.recentProjectImage}
                            loading="lazy"
                        />
                    ) : (
                        <div className={styles.imagePlaceholder}>No Image</div>
                    )}
                </div>
                <div className={`${styles.recentProjectDetails} ${styles.scoreCardDetails}`}>
                    <div className={styles.recentProjectDetailsTop}>
                        <div className={styles.cardTitle}>{title || result.asin || 'Untitled product'}</div>
                        <div className={styles.scoreDotRow}>
                            <span className={styles.scoreDot} style={{ background: getScoreColor(score) }} />
                            <span>{hasScore ? `${convertToPoints(score)}/10` : 'No score'}</span>
                        </div>
                        <div className={styles.recentProjectIdTag}>
                            <span>{result.asin || 'N/A'}</span>
                        </div>
                    </div>
                    <div className={styles.cardDate}>
                        <span>{formatScoreDate(result.created_at)}</span>
                    </div>
                </div>
            </div>
            <div className={styles.recentProjectScoreBadge}>
                <span>Score</span>
            </div>
        </div>
    );
};

export default SingleScoreCard;
